export const FETCH_CONSTANTS_REQUEST = 'FETCH_CONSTANTS_REQUEST';
export const FETCH_CONSTANTS_SUCCESS = 'FETCH_CONSTANTS_SUCCESS';

export const AGENT_PROFILE_SERVICE_COMPLETE = 'AGENT_PROFILE_SERVICE_COMPLETE';

export const SET_AGENT_PROFILE_STEP_REQUEST = 'SET_AGENT_PROFILE_STEP_REQUEST';
export const SET_AGENT_PROFILE_STEP_SUCCESS = 'SET_AGENT_PROFILE_STEP_SUCCESS';

export const SAVE_USER_PROFILE_NEW_REQUEST = 'SAVE_USER_PROFILE_NEW_REQUEST';
export const SAVE_USER_PROFILE_IN_PROGRESS_REQUEST = 'SAVE_USER_PROFILE_IN_PROGRESS_REQUEST';
export const SAVE_USER_PROFILE_SUCCESS = 'SAVE_USER_PROFILE_SUCCESS';

export const FETCH_CURRENT_USER_PROFILE_REQUEST = 'FETCH_CURRENT_USER_PROFILE_REQUEST';
export const FETCH_CURRENT_USER_PROFILE_SUCCESS = 'FETCH_CURRENT_USER_PROFILE_SUCCESS';

export const SAVE_COMPANY_PROFILE_REQUEST = 'SAVE_COMPANY_PROFILE_REQUEST';
export const SAVE_COMPANY_PROFILE_SUCCESS = 'SAVE_COMPANY_PROFILE_SUCCESS';

export const SAVE_SERVICE_FEE_REQUEST = 'SAVE_SERVICE_FEE_REQUEST';
export const SAVE_SERVICE_FEE_SUCCESS = 'SAVE_SERVICE_FEE_SUCCESS';

export const FETCH_REGION_COVERAGE_REQUEST = 'FETCH_REGION_COVERAGE_REQUEST';
export const FETCH_REGION_COVERAGE_SUCCESS = 'FETCH_REGION_COVERAGE_SUCCESS';

export const FETCH_SLA_TARGETS_REQUEST = 'FETCH_SLA_TARGETS_REQUEST';
export const FETCH_SLA_TARGETS_SUCCESS = 'FETCH_SLA_TARGETS_SUCCESS';

export const SAVE_REGION_COVERAGE_REQUEST = 'SAVE_REGION_COVERAGE_REQUEST';
export const SAVE_REGION_COVERAGE_SUCCESS = 'SAVE_REGION_COVERAGE_SUCCESS';

export const SAVE_PROFESSIONAL_INFO_REQUEST = 'SAVE_PROFESSIONAL_INFO_REQUEST';
export const SAVE_PROFESSIONAL_INFO_SUCCESS = 'SAVE_PROFESSIONAL_INFO_SUCCESS';

export const SAVE_E_AND_O_INFO_REQUEST = 'SAVE_E_AND_O_INFO_REQUEST';
export const SAVE_E_AND_O_INFO_SUCCESS = 'SAVE_E_AND_O_INFO_SUCCESS';

export const SET_E_AND_O_DOCS = 'SET_E_AND_O_DOCS';

export const DELETE_E_AND_O_DOCUMENT_REQUEST = 'DELETE_E_AND_O_DOCUMENT_REQUEST';
export const DELETE_E_AND_O_DOCUMENT_SUCCESS = 'DELETE_E_AND_O_DOCUMENT_SUCCESS';

export const SAVE_CREDENTIALS_REQUEST = 'SAVE_CREDENTIALS_REQUEST';
export const SAVE_CREDENTIALS_SUCCESS = 'SAVE_CREDENTIALS_SUCCESS';

export const DELETE_CREDENTIAL_DOCUMENT_REQUEST = 'DELETE_CREDENTIAL_DOCUMENT_REQUEST';
export const DELETE_CREDENTIAL_DOCUMENT_SUCCESS = 'DELETE_CREDENTIAL_DOCUMENT_SUCCESS';

export const ADD_CREDENTIAL_DOCUMENTS = 'ADD_CREDENTIAL_DOCUMENTS';

export const SAVE_COMPLETE_PROFILE_SUCCESS = 'SAVE_COMPLETE_PROFILE_SUCCESS';

export const UPDATE_APPLICATION_STATUS_REQUEST = 'UPDATE_APPLICATION_STATUS_REQUEST';
export const UPDATE_APPLICATION_STATUS_SUCCESS = 'UPDATE_APPLICATION_STATUS_SUCCESS';

export const APPROVE_APPLICATION_REQUEST = 'APPROVE_APPLICATION_REQUEST';
export const APPROVE_APPLICATION_SUCCESS = 'APPROVE_APPLICATION_SUCCESS';

export const FETCH_APPLICATION_MESSAGES_REQUEST = 'FETCH_APPLICATION_MESSAGES_REQUEST';
export const FETCH_APPLICATION_MESSAGE_LIST_SUCCESS = 'FETCH_APPLICATION_MESSAGE_LIST_SUCCESS';

export const ADD_APPLICATION_MESSAGE_REQUEST = 'ADD_APPLICATION_MESSAGE_REQUEST';
export const ADD_APPLICATION_MESSAGE_SUCCESS = 'ADD_APPLICATION_MESSAGE_SUCCESS';

export const setAgentProfileStepRequest = stepType => ({
  type: SET_AGENT_PROFILE_STEP_REQUEST,
  payload: { stepType },
});

export const setAgentProfileStepSuccess = stepType => ({
  type: SET_AGENT_PROFILE_STEP_SUCCESS,
  payload: { stepType },
});

export const fetchConstantsRequest = () => ({
  type: FETCH_CONSTANTS_REQUEST,
  payload: null,
});

export const fetchConstantsSuccess = constants => ({
  type: FETCH_CONSTANTS_SUCCESS,
  payload: { constants },
});

export const saveUserProfileRequest = (nextStep, isAuthenticated, userProfile) => ({
  type: isAuthenticated ? SAVE_USER_PROFILE_IN_PROGRESS_REQUEST : SAVE_USER_PROFILE_NEW_REQUEST,
  payload: { userProfile, nextStep },
});

export const saveUserProfileSuccess = userProfile => ({
  type: SAVE_USER_PROFILE_SUCCESS,
  payload: { userProfile },
});

export const serviceComplete = () => ({
  type: AGENT_PROFILE_SERVICE_COMPLETE,
  payload: null,
});

export const fetchCurrentUserProfileRequest = (accessToken, applicationId) => ({
  type: FETCH_CURRENT_USER_PROFILE_REQUEST,
  payload: { accessToken, applicationId },
});

export const fetchCurrentUserProfileSuccess = currentUser => ({
  type: FETCH_CURRENT_USER_PROFILE_SUCCESS,
  payload: { currentUser },
});

export const saveCompanyProfileRequest = (nextStep, companyProfile) => ({
  type: SAVE_COMPANY_PROFILE_REQUEST,
  payload: { nextStep, companyProfile },
});

export const saveCompanyProfileSuccess = companyProfile => ({
  type: SAVE_COMPANY_PROFILE_SUCCESS,
  payload: { companyProfile },
});

export const saveServiceFeeRequest = serviceFeeList => ({
  type: SAVE_SERVICE_FEE_REQUEST,
  payload: { serviceFeeList },
});

export const saveServiceFeeSuccess = serviceFeeList => ({
  type: SAVE_SERVICE_FEE_SUCCESS,
  payload: { serviceFeeList },
});

export const fetchRegionCoverageRequest = zipCode => ({
  type: FETCH_REGION_COVERAGE_REQUEST,
  payload: { zipCode },
});

export const fetchRegionCoverageSuccess = regionCoverage => ({
  type: FETCH_REGION_COVERAGE_SUCCESS,
  payload: { regionCoverage },
});

export const fetchSlaTargetsRequest = zipCode => ({
  type: FETCH_SLA_TARGETS_REQUEST,
  payload: { zipCode },
});

export const fetchSlaTargetsSuccess = slaTargets => ({
  type: FETCH_SLA_TARGETS_SUCCESS,
  payload: { slaTargets },
});

export const saveRegionCoverageRequest = (nextStep, regionCoverage) => ({
  type: SAVE_REGION_COVERAGE_REQUEST,
  payload: { nextStep, regionCoverage },
});

export const saveRegionCoverageSuccess = regionCoverage => ({
  type: SAVE_REGION_COVERAGE_SUCCESS,
  payload: { regionCoverage },
});

export const saveProfessionalInfoRequest = (nextStep, professionalInfo) => ({
  type: SAVE_PROFESSIONAL_INFO_REQUEST,
  payload: { nextStep, professionalInfo },
});

export const saveProfessionalInfoSuccess = professionalInfo => ({
  type: SAVE_PROFESSIONAL_INFO_SUCCESS,
  payload: { professionalInfo },
});

export const saveEandOInfoRequest = (nextStep, eandoInfo) => ({
  type: SAVE_E_AND_O_INFO_REQUEST,
  payload: { nextStep, eandoInfo },
});

export const saveEandOInfoSuccess = eandoInfo => ({
  type: SAVE_E_AND_O_INFO_SUCCESS,
  payload: { eandoInfo },
});

export const deleteEandODocumentRequest = documentId => ({
  type: DELETE_E_AND_O_DOCUMENT_REQUEST,
  payload: { documentId },
});

export const deleteEandODocumentSuccess = documentId => ({
  type: DELETE_E_AND_O_DOCUMENT_SUCCESS,
  payload: { documentId },
});

export const setEandODocsRequest = documentList => ({
  type: SET_E_AND_O_DOCS,
  payload: { documentList },
});

export const saveCredentialsRequest = (nextStep, credentials) => ({
  type: SAVE_CREDENTIALS_REQUEST,
  payload: { nextStep, credentials },
});

export const saveCredentialsSuccess = credentials => ({
  type: SAVE_CREDENTIALS_SUCCESS,
  payload: { credentials },
});

export const setCredentialDocuments = documentList => ({
  type: ADD_CREDENTIAL_DOCUMENTS,
  payload: { documentList },
});

export const deleteCredentialDocumentRequest = documentId => ({
  type: DELETE_CREDENTIAL_DOCUMENT_REQUEST,
  payload: { documentId },
});

export const deleteCredentialDocumentSuccess = documentId => ({
  type: DELETE_CREDENTIAL_DOCUMENT_SUCCESS,
  payload: { documentId },
});

export const saveCompleteProfileSuccess = () => ({
  type: SAVE_COMPLETE_PROFILE_SUCCESS,
  payload: null,
});

export const updateApplicationStatusRequest = status => ({
  type: UPDATE_APPLICATION_STATUS_REQUEST,
  payload: { status },
});

export const updateApplicationStatusSuccess = status => ({
  type: UPDATE_APPLICATION_STATUS_SUCCESS,
  payload: { status },
});

export const approveApplicationRequest = status => ({
  type: APPROVE_APPLICATION_REQUEST,
  payload: { status },
});

export const fetchApplicationMessageListRequest = () => ({
  type: FETCH_APPLICATION_MESSAGES_REQUEST,
  payload: null,
});

export const fetchApplicationMessagesSuccess = messageList => ({
  type: FETCH_APPLICATION_MESSAGE_LIST_SUCCESS,
  payload: { messageList },
});

export const addApplicationMessageRequest = messageText => ({
  type: ADD_APPLICATION_MESSAGE_REQUEST,
  payload: { messageText },
});

export const addApplicationMessageSuccess = newMessage => ({
  type: ADD_APPLICATION_MESSAGE_SUCCESS,
  payload: { newMessage },
});
